import React, { useState } from 'react';
import { Spin, Modal } from 'antd';
import { createCommunityResource } from '../../../services/communityService';
import CommunityResourceForm from './CommunityResourceForm';

const AddCommunityResource = ({ isOpen, onCancelModal }) => {
  const initialValues = {
    title: '',
    description: '',
    link: '',
    type: 'external_link',
    topic: '',
    thumbnail: '',
    topicIndex: '',
    subIndex: '',
    communityObjectId: ''
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    await createCommunityResource(values)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };
  return (
    <Modal
      title={`Add Community Event`}
      visible={isOpen}
      onCancel={() => onCancelModal()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <CommunityResourceForm
          initialValues={initialValues}
          setStatus={setStatus}
          status={status}
          type="Add"
          onSubmit={onSubmit}
        />
      )}
    </Modal>
  );
};

export default AddCommunityResource;
